<template>
	<div id="comperhensive">
		<!-- 上 -->
		<div class="comperhensive_top">
			<!-- 左 -->
			<div class="comperhensive_top_left">
				<div class="login_kuang yingying" v-if="!logintrue">
					<div style="height: 150px;padding: 15px;">
						<img src="../imges/hgro2.jpg" style="width: 100%;height: 100%;" alt="">
					</div>
					<div class="denglu_kuang">
						<input v-model="user.username" class="denginput" placeholder="请输入用户名" type="text">
					</div>
					<div class="denglu_kuang">
						<input v-model="user.password" class="denginput" style="width: 65%;" placeholder="请输入密码"
							type="password">
						<span @click="changePawword">
							忘记密码
						</span>
					</div>
					<div class="lozc">
						<div class="lozclfet aaa___" @click="login">登录</div>
						<div class="lozcright aaa___" @click="registers">
							注册
						</div>
					</div>
				</div>
				<div class="login_kuang yingying" v-if="logintrue">
					<div style="height: 150px;padding: 15px;">
						<img src="../imges/hgro.jpg" style="width: 100%;height: 100%;" alt="">
					</div>
					<div style="width: 30%;height: 100px;text-align: center;float: left;position: relative;">
						<div
							style="width: 50px;height: 50px;border-radius: 50%;position: absolute;top: 35px;left: 30%;overflow: hidden;">
							<img style="width: 100%;height: 100%;"
								:src=" 'https://admin.shipoe360.com/public/' + wcnmlgb.icon " alt="">
						</div>
					</div>
					<div style="width: 50%;height: 100px;text-align: center;line-height:100px;color: red;float: left;">
						{{wcnmlgb.nickname}}
					</div>
					<div
						style="width: 50%;height: 40px;text-align: center;line-height:40px;float: left;font-size: 12px;">
						余额：<span style="color: orange;">{{wcnmlgb.rmb}} </span>
					</div>
					<div
						style="width: 50%;height: 40px;text-align: center;line-height:40px;float: left;font-size: 12px;">
						积分：<span style="color: orange;">{{wcnmlgb.money}}</span>
					</div>
					<router-link to="/user" tag="div"
						style="width: 25%;height: 20px;text-align: center;line-height:20px;font-weight: 800;float: left;margin-left: 20%;">
						会员中心
					</router-link>
					<router-link to="/user" tag="div"
						style="width: 15%;height: 20px;text-align: center;line-height:20px;font-weight: 800;float: left;">
						进入
					</router-link>
					<div @click="tuchu"
						style="width: 15%;height: 20px;text-align: center;line-height:20px;font-weight: 800;float: left;">
						退出
					</div>
				</div>
			</div>
			<!-- 中 -->
			<div class="comperhensive_top_center">
				<div class="zh_kuang">
					<div class="zh_kuang_a">
						<div class="zh_kuang_a_">
							<div class="zh_kuang_a_title_o">{{myTime.data}} <br> {{myTime.time}}</div>
						</div>
						<div class="zh_kuang_a_">
							<div class="zh_kuang_a_title" style="margin-top: 10px;">
								{{tianqi.city}}
							</div>
							<div class="zh_kuang_a_title_o" style="line-height: 20px;margin-top: 5px;">
								<!-- <span style="font-size:15px;color: #000;">空气质量：</span> -->
								<span>空气质量:</span>
								<span
									style="color: #b72323;display: inline-block;background: #FFFF82;margin-top: 15px;">良</span>
							</div>
						</div>
					
					</div>
					<div class="zh_kuang_b">
						<input style="padding-left: 5%;height: 45px;" type="text" placeholder="请输入搜索关键词"
							v-model="searchData">
						<div class="zh_kuang_b_R" style="height: 47px;line-height: 47px;" @click="SearchDaquans">
							搜&nbsp;&nbsp;&nbsp;索
						</div>
					</div>
					<div class="zh_kuang_c">
						<el-breadcrumb>
							<el-breadcrumb-item style="margin-left: 5%;" :to="{ path: '/user' }">发图片
							</el-breadcrumb-item>
							<el-breadcrumb-item :to="{ path: '/user' }">发资讯</el-breadcrumb-item>
							<el-breadcrumb-item :to="{ path: '/user' }">发视频</el-breadcrumb-item>
							<el-breadcrumb-item :to="{ path: '/user' }">发产品</el-breadcrumb-item>
							<el-breadcrumb-item :to="{ path: '/user' }">发招聘</el-breadcrumb-item>
							<el-breadcrumb-item :to="{ path: '/user' }">发简历</el-breadcrumb-item>
							<el-breadcrumb-item :to="{ path: '/user' }">发需求</el-breadcrumb-item>
						</el-breadcrumb>
					</div>
					<div class="zh_kuang_c">
						<!-- <div class="zh_huang_c_a">
							<span style="font-size:16px;" class="el-icon-view"></span>
							<span style="font-size:16px;">平台访问</span>
							<span style="color:#E82904;font-size:14px;line-height: 30px;">{{info.view_num}}</span>
						</div> -->
						<div class="zh_huang_c_a" style="margin-left: 2%;">
							<span style="font-size:16px;" class="el-icon-office-building"></span>
							<span style="font-size:16px;">入驻用户</span>
							<span style="color:#E82904;font-size:14px;line-height: 30px;">{{info.qiye_num}}</span>
						</div>
						<div class="zh_huang_c_a" style="float: right;">
							<span style="font-size:16px;" class="el-icon-edit-outline"></span>
							<span style="font-size:16px;">用户发布</span>
							<span style="color:#E82904;font-size:14px;line-height: 30px;">{{info.add_num}}</span>
						</div>
					</div>
					<div class="zh_kuang_d">
						<div class="zh_kuang_d_l">
							<i class="el-icon-message-solid" style="color: #E82904;font-size: 24px;"></i>
						</div>
						<div class="zh_kuang_d_r" @click="gotogonggao(arr.content,arr.title)">
							<marquee><span>{{arr.title}}</span></marquee>
						</div>
					</div>
				</div>
			</div>
			<!-- 右 -->
			<div class="comperhensive_top_right">
				<div class="login_kuang">
					<div class="login_kuang_top">
						<div class="login_kuang_top_img">
							<img src="../imges/sy.png" style="width: 100%;height: 100%;" alt="">
						</div>
						<div class="login_kuang_top_title">
							用户积分排行榜
						</div>
					</div>
					<vue-seamless-scroll :data="profitList" class="listUP">
						<div class="profit_list " v-for="(item,index) in profitList" :key="index">
							<div style="width:15%;">
								<span
									:class="{ 'font_color_1': index == 0, 'font_color_2': index == 1, 'font_color_3': index == 2, 'font_color_4': index >= 3}">{{index + 1}}</span>
							</div>
							<div style="width:56%;text-align:left;padding-left:8px;">
								{{`${item.nickname}`.substring(0,1)}}&nbsp; *&nbsp;*
								&nbsp;{{`${item.nickname}`.substring(3,4)}}
							</div>
							<div style="width:25%;min-width:40px;color: red;font-weight: 600;">{{item.pay_points}}
							</div>
						</div>
					</vue-seamless-scroll>
				</div>
			</div>
		</div>
		<!-- 下 -->
		<div class="comperhensive_bottom">
			<div class="z_warp-left-bot" :class="{ 'height_active': isRET }" style="">
				<div class="gd_right" @click="rightGD" v-if="isRETGD">
					<span style="position: absolute;left: -5px;top: -7px;">+</span>
				</div>

				<div class="gd_right" ref="linkHight" @click="rightGDQ" v-if="isRETGDQ">
					<span style="position: absolute;left: -5px;top: -7px;">-</span>
				</div>
				<div class="thirdParty1 gd_img" style="width: 140%;">
<!--					<div class="qqp1" :class="{ 'qqq1-q':isQQQ1 }" @click="newgotoDeils()">-->
<!--						<div class="qqp1_img">-->
<!--							<img src="../imges/list/vrdt.png" alt="">-->
<!--						</div>-->
<!--						<div style="margin-top: 5px;">企业VR</div>-->
<!--					</div>-->
					<div class="qqp1" :class="{ 'qqq1-q':isQQQ1 }" v-for="item in vrlist" :key="item.id"
						@click="gotoDeils(item.routerAdress,item)">
						<div class="qqp1_img">
							<img :src="item.img_url" alt="">
						</div>
						<div style="margin-top: 5px;">{{item.img_title}}</div>
					</div>
				</div>
				<div class="guanbi" v-show="isRET" @click="gbnav">
					<img src="../imges/list/gbgb.png" alt="点击关闭">
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import http from "@/utils/http";
	import vueSeamlessScroll from 'vue-seamless-scroll'
	export default {
		data() {
			return {
				profitList: [],
				wcnmlgb: '',
				myTime: {
					data: '',
					week: '',
					time: ''
				},
				user: {
					username: '',
					password: ''
				},
				arr: [],
				tianqi: {},
				info: {
					view_num: 0,
					qiye_num: 0,
					add_num: 0
				},
				logintrue: false,
				// 绝对定位符
				isRET: false,
				qwerip: '',
				ip: '',
				isRETGD: true,
				isRETGDQ: false,
				isKz: false,
				isQQQ1: false,
				searchData: '',
				vrlist: [{
						id: 2,
						img_url: require('../imges/list/vrdt.png'),
						img_title: '船海地图',
						routerAdress: 'Vrmap'
					},
					{
						id: 31,
						img_url: require('../imges/list/qydq.png'),
						img_title: '企业大全',
						routerAdress: 'qydq'
					},
					// {
					// 	id: 5,
					// 	img_url: require('../imges/list/xptj.png'),
					// 	img_title: '新品推荐',
					// 	routerAdress: 'xptj'
					// },
					{
						id: 6,
						img_url: require('../imges/list/zjzk.png'),
						img_title: '专家智库',
						routerAdress: 'zjzk'
					}, {
						id: 32,
						img_url: require('../imges/list/hyhd.png'),
						img_title: '行业资讯',
						routerAdress: 'hyzx'
					},
					// {
					// 	id: 7,
					// 	img_url: require('../imges/list/zpqz.png'),
					// 	img_title: '求职招聘',
					// 	routerAdress: 'qzzp'
					// },
					{
						id: 8,
						img_url: require('../imges/list/chtk.png'),
						img_title: '船舶船型',
						routerAdress: 'ctxz'
					},
					// {
					// 	id: 12,
					// 	img_url: require('../imges/list/dkyj.png'),
					// 	img_title: '交流中心',
					// 	routerAdress: 'dk',
					// },
					{
						id: 15,
						img_url: require('../imges/list/jrsp.png'),
						img_title: '今日视频',
						routerAdress: 'jrsp'
					}, {
						id: 16,
						img_url: require('../imges/list/zhhy.png'),
						img_title: '展会会议',
						routerAdress: 'zhhy'
					}, {
						id: 17,
						img_url: require('../imges/list/txl.png'),
						img_title: '名片大全',
						routerAdress: 'txl'
					},
					// {
					// 	id: 19,
					// 	img_url: require('../imges/PPT.png'),
					// 	img_title: 'PPT分享',
					// 	routerAdress: 'rwdt'
					// },
					// {
					// 	id: 20,
					// 	img_url: require('../imges/list/hyhd.png'),
					// 	img_title: '会员活动',
					// 	routerAdress: 'hyhd'
					// },
					{
						id: 25,
						img_url: require('../imges/qkyd.png'),
						img_title: '期刊阅读',
						routerAdress: 'bkqk'
					},
					// {
					// 	id: 26,
					// 	img_url: require('../imges/zptga.png'),
					// 	img_title: '招标通告',
					// 	routerAdress: 'zbtg'
					// },
					// {
					// 	id: 23,
					// 	img_url: require('../imges/list/bmzx.png'),
					// 	img_title: '便民中心',
					// 	routerAdress: 'bmzx'
					// },
					{
						id: 45,
						img_url: require('../imges/list/bmzx.png'),
						img_title: '直播互动',
						routerAdress: 'zbhd'
					}
				],
			}
		},
		components: {
			vueSeamlessScroll
		},
		methods: {
			//可不要
			getDate() {
				var today = new Date();
				var date = today.getFullYear() + "-" + this.twoDigits(today.getMonth() + 1) + "-" + this.twoDigits(today
						.getDate()) +
					" ";
				var week = " 星期" + "日一二三四五六 ".charAt(today.getDay());
				var time = this.twoDigits(today.getHours()) + ": " + this.twoDigits(today.getMinutes()) + ": " + this
					.twoDigits(
						today.getSeconds());
				this.myTime.data = date
				this.myTime.week = week
				this.myTime.time = time
			},
			newgotoDeils() {
				this.$router.push('/Vrshow');
			},
			gotoDeils(path) {
				if (path == '') {} else if (path == 'rwdt') {
					document.querySelector("#rwdt").scrollIntoView(true);
				} else if (path == 'txl') {
					document.querySelector("#txl").scrollIntoView(true);
				} else if (path == 'Vrshow') {
					// document.querySelector("#qyVRqj").scrollIntoView(true);
					this.$router.push('/Vrshow');

				} else if (path == 'Vrmap') {
					document.querySelector("#hhdt").scrollIntoView(true);
				} else if (path == 'sc') {
					document.querySelector("#zzsc").scrollIntoView(true);
					// window.open('http://demo.csomepc.com/index.php/Home/Goods/goodsList/id/857.html', "_self")
				} else if (path == 'qydq') {
					document.querySelector("#qydq").scrollIntoView(true);
				} else if (path == 'xptj') {
					document.querySelector("#xptj").scrollIntoView(true);
				} else if (path == 'zjzk') {
					document.querySelector("#zjzk").scrollIntoView(true);
				} else if (path == 'hyzx') {
					document.querySelector("#hyzx").scrollIntoView(true);
				} else if (path == 'qzzp') {
					document.querySelector("#qzzp").scrollIntoView(true);
				} else if (path == 'ctxz') {
					document.querySelector("#ctxz").scrollIntoView(true);
				} else if (path == 'dk') {
					document.querySelector("#dk").scrollIntoView(true);
				} else if (path == 'jrsp') {
					document.querySelector("#jrsp").scrollIntoView(true);
				} else if (path == 'zhhy') {
					document.querySelector("#zhhy").scrollIntoView(true);
				} else if (path == 'hyhd') {
					document.querySelector("#hyhd").scrollIntoView(true);
				} else if (path == 'bkqk') {
					document.querySelector("#bkqk").scrollIntoView(true);
				} else if (path == 'bmzx') {
					document.querySelector("#bmzx").scrollIntoView(true);
				} else if (path == 'zbtg') {
					document.querySelector("#zbtg").scrollIntoView(true);
				} else if (path == 'zbhd') {
					document.querySelector("#zbhd").scrollIntoView(true);
				}else {
					// //console.log(path)
					this.$router.push(path)
				}
			},
			tuchu() {
				this.$message.success('退出登录成功！')
				sessionStorage.removeItem('token');
				sessionStorage.removeItem('user');
				this.logintrue = !this.logintrue
			},
			SearchDaquans() {
				this.$router.push({
					path: '/SearchDaquandetails',
					query: {
						id: this.searchData
					}
				})
			},
			gotogonggao(name, title) {
				this.$router.push({
					path: '/gonggao',
					query: {
						name: name,
						title: title
					}
				})
			},
			twoDigits(val) {
				if (val < 10) return "0" + val;
				return val;
			},
			watchGD() {
				let a = window.pageYOffset;
				if (a > 1200) {
					this.isRET = true
				} else {
					this.isRET = false
					this.qwqery = false
				}
			},
			rightGD() {
				this.isQQQ1 = true
				this.isRETGDQ = true
				this.isRETGD = false
			},
			gbnav() {
				clearInterval(this.refreshIntervalId);
				this.isRET = false
				this.poiuy = true
			},
			rightGDQ() {
				this.isRETGDQ = false
				this.isRETGD = true
				this.isQQQ1 = false
			},
			async login() {
				let res = await http.post('api/login/login', {
					username: this.user.username,
					password: this.user.password
				})
				console.log(res)
				sessionStorage.setItem('token', JSON.stringify(res.data.data.token))
				sessionStorage.setItem('user', JSON.stringify(res.data.data.user))
				if (res.data.msg == 'success') {
					this.logintrue = !this.logintrue
					const loginInfo = JSON.parse(window.sessionStorage.getItem('user') || null)
					let res = await http.get('api/picture/grzx', {
						uid: loginInfo.id
					})
					this.wcnmlgb = res.data.data[0]
				} else {
					alert(res.data.msg)
				}
			},
			changePawword() {
				this.$router.replace('/changePassword')
			},
			registers() {
				this.$router.replace('/register')
			},

			ready: function() {
				// var cip = returnCitySN["cip"];
				// sessionStorage.setItem('cip', JSON.stringify(cip))
				const ips = JSON.parse(window.sessionStorage.getItem('cip') || null)
				console.log(cip)
				this.qwerip = cip
				// console.log(this.qwerip)
			}
		},
		async mounted() {
			let res = await http.get('api/profit/profit')
			this.profitList = res.data.data.pofitList

			let res1 = await http.get('api/picture/info')
			this.info.view_num = res1.data.data.view_num
			console.log(this.info.view_num)
			this.info.qiye_num = res1.data.data.qiye_num
			this.info.add_num = res1.data.data.add_num

			let res2 = await http.post('api/Common/index', {
				model: 'gonggao',
				type: 'content',
				mid: '6',
			})
			this.arr = res2.data.data.list.data[0]

			this.refreshIntervalId = setInterval(this.watchGD, 1000)

			// 必要时清除
			setInterval(this.getDate, 1000);
			//
			const loginInfo = JSON.parse(window.sessionStorage.getItem('user') || null)
			if (loginInfo) {
				this.logintrue = true
				let res = await http.get('api/picture/grzx', {
					uid: loginInfo.id
				})
				// console.log(res)
				this.wcnmlgb = res.data.data[0]
				console.log(this.wcnmlgb)
			} else {
				this.logintrue = false
			}
			this.ready()

			this.$axios.get("https://tianqiapi.com/api?appid=27557114&appsecret=AOomj4JW&version=v6&ip=" + this.qwerip)
				.then(res => {
					this.tianqi = res.data
					console.log('天气++++', this.tianqi)
				}).catch(err => {
					this.tianqi = err
				});
		}
	}
</script>

<style>
	#comperhensive {
		width: 100%;
		height: 450px;
		border-radius: 15px;
		/* box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.16); */
		box-shadow: 10px 20px 10px -15px rgb(231, 231, 231);
		overflow: hidden;
	}

	.comperhensive_top {
		width: 100%;
		height: 370px;
	}

	/* 左 */
	.comperhensive_top_left {
		width: 25%;
		height: 370px;
		float: left;
	}

	.login_kuang {
		width: 90%;
		height: 350px;
		margin: 10px auto;
		border-radius: 10px;
		overflow: hidden;
	}

	.yingying {
		box-shadow: #6e6e6e 0px 0px 4px;
	}

	.denglu_kuang {
		width: 90%;
		height: 30px;
		border-radius: 30px;
		background: #F7F8FA;
		margin: 0 auto;
		margin-top: 10px;
	}

	.denglu_kuang>span {
		display: inline-block;
		float: right;
		font-size: 12px;
		color: grey;
		line-height: 30px;
		margin-right: 7px;
		cursor: pointer;
	}

	.lozc {
		width: 90%;
		height: 30px;
		margin: 0 auto;
		margin-top: 20px;
	}

	.lozclfet {
		background: rgb(217, 34, 11);
		color: rgb(255, 255, 255);
	}

	.aaa___ {
		text-decoration: none;
		display: inline-block;
		min-width: 80px;
		width: 40%;
		max-width: 120px;
		margin-left: 6%;
		text-align: center;
		height: 28px;
		line-height: 28px;
		letter-spacing: 2px;
		font-size: 15px;
		border-radius: 20px;
		cursor: pointer;
	}

	.lozcright {
		border: 1px solid rgb(217, 34, 11);
		color: rgb(217, 34, 11);
	}

	.denginput {
		width: 85%;
		border: 0px;
		background: #F7F8FA;
		;
		margin-left: 15px;
		margin-top: 7px;
		outline: none;
	}

	/* 中 */
	.comperhensive_top_center {
		width: 50%;
		height: 370px;
		float: left;
	}

	.zh_kuang {
		width: 90%;
		height: 350px;
		margin: 10px auto;
	}

	.zh_kuang_a {
		width: 100%;
		height: 85px;
	}

	.zh_kuang_a_ {
		width: 27%;
		height: 85px;
		margin-left: 5%;
		float: left;
	}

	.zh_kuang_a_title {
		font-size: 16px;
		text-align: center;
		margin-top: 20px;
	}

	.zh_kuang_a_title_o {
		text-align: center;
		font-size: 18px;
		line-height: 40px;
	}

	.zh_kuang_b {
		width: 95%;
		height: 60px;
		margin: 0 auto;
		margin-top: 20px;
		padding-left: 5%;
	}

	.zh_kuang_b>input {
		width: 70%;
		height: 56px;
		float: left;
		outline: none;
		border: 0px;
		box-shadow: rgba(0, 0, 0, 0.08) 0px 3px 12px;
		/* margin-left: 4.5%; */
	}

	.zh_kuang_b_R {
		width: 20%;
		height: 59px;
		background-color: #db2b2b;
		float: left;
		border-radius: 0px 8px 8px 0px;
		text-align: center;
		line-height: 32px;
		font-size: 14px;
		font-weight: 800;
		color: #FFF;
	}

	.zh_kuang_c {
		width: 90%;
		height: 30px;
		margin: 0 auto;
		margin-top: 20px;
	}

	.zh_huang_c_a {
		float: left;
		width: 28.5%;
		height: 30px;
		line-height: 30px;
		overflow: hidden;
	}

	.zh_kuang_d {
		width: 90%;
		height: 40px;
		margin: 0 auto;
		margin-top: 20px;
	}

	.zh_kuang_d_l {
		width: 10%;
		height: 40px;
		background: #FFF;
		text-align: center;
		line-height: 40px;
		float: left;
	}

	.zh_kuang_d_r {
		width: 90%;
		height: 40px;
		float: left;
		background-color: rgb(245, 244, 244);
		line-height: 40px;
		font-weight: bolder;
		font-size: 18px;
		color: black;
	}

	/* 右 */
	.comperhensive_top_right {
		width: 25%;
		height: 370px;
		float: left;
	}

	.login_kuang_top {
		width: 100%;
		height: 50px;
		background: #ffc8c0;
		z-index: 99;
	}

	.login_kuang_top_img {
		width: 20px;
		height: 20px;
		float: left;
		margin-top: 15px;
		margin-left: 60px;
	}

	.login_kuang_top_title {
		margin-top: 10px;
		float: left;
		color: crimson;
		font-weight: 800;
		font-size: 17px;
		height: 26px;
		line-height: 26px;
		margin-left: 6px;
	}

	.listUP {
		-webkit-animation: 16s listUP linear infinite normal;
		animation: 16s listUP linear infinite normal;
		/* 如果不懂就是这里的问题 */
		/* position: relative; */
		overflow: hidden;
	}

	.profit_list::after,
	.profit_warp_top_::after {
		display: block;
		clear: both;
		content: '';
	}

	.profit_list {
		border-bottom: 1px solid #f4f4f4;
		font-size: 14px;
	}

	.profit_list>div,
	.profit_warp_top_>div {
		float: left;
		text-align: center;
		padding: 7px 0px;
	}

	.font_color_1 {
		padding: 2px 6px;
		background-color: #db2b2b;
	}

	.font_color_2 {
		padding: 2px 6px;
		background-color: #db712b;
	}

	.font_color_3 {
		padding: 2px 6px;
		background-color: #e6b632;
	}

	.font_color_4 {
		padding: 2px 6px;
		background-color: #f0f0f0;
	}

	/* 下 */

	.comperhensive_bottom {
		width: 100%;
		height: 80px;
	}

	.tq_icon_warp::after,
	.tianq::after,
	.thirdParty1::after,
	.thirdParty::after,
	.search_sty::after,
	.search_warp>div::after,
	.z_warp-left-top::after,
	.z_warp-left-bot::after,
	.center_top:after {
		display: block;
		clear: both;
		content: '';
	}

	.z_warp-left-bot>div {
		float: left;
	}

	.z_warp-left-bot {
		position: relative;
		overflow: hidden;
	}

	.gd_left,
	.gd_right {
		color: #37A4EC;
		font-size: 28px;
		text-align: center;
		line-height: 21px;
		width: 20px;
		height: 20px;
		position: absolute;
		top: 60px;
		cursor: pointer;
		z-index: 999;
		right: 2px !important;
	}

	.thirdParty1>div {
		height: 75px;
		margin-left: 24px;
		width: 74px;
		cursor: pointer;
		position: relative;
		display: inline-block;
	}

	.thirdParty1>div>.qqp1_img {
		display: flex;
		align-items: center;
		justify-content: center;
		width: 50px;
		height: 50px;
		margin: 0 auto;
		box-shadow: 20px 20px 32px rgba(0, 0, 0, 0.2),
			-20px -20px 32px rgba(255, 255, 255, 1);
		border-radius: 20px;
		transition: box-shadow .2s ease-out;
		background: #efeeee;
	}


	.thirdParty1>div>.qqp1_img:hover {
		display: flex;
		align-items: center;
		justify-content: center;
		box-shadow: 0 0 0 rgba(0, 0, 0, 0.2),
			0 0 0 rgba(255, 255, 255, 1),
			inset 20px 20px 32px rgba(0, 0, 0, 0.1),
			inset -20px -20px 32px rgba(255, 255, 255, 1);
		/*内嵌投影值*/
		transition: box-shadow .2s ease-out;
	}

	.thirdParty1>div>.qqp1_img:hover img {

		width: 78%;
		height: 78%;
		transition: width .2s ease-out;
	}


	.thirdParty1>div>.qqp1_img>img {
		width: 80%;
		height: 80%;
		transition: width .2s ease-out;
	}

	.thirdParty1>div>div:last-child {
		margin-top: 3px;
		font-size: 12px;
		font-weight: 600;
		text-align: center;
	}

	.guanbi {
		position: absolute;
		right: -3px;
		top: 0px;
		width: 25px;
		height: 25px;
		z-index: 999;
		border-radius: 50%;
		overflow: hidden;
		cursor: pointer;
	}

	.height_active {
		width: 1190px !important;
		margin: 0 auto;
		position: fixed !important;
		top: 0;
		z-index: 999;
		background-color: #fff;
		box-shadow: 2px 2px 2px 2px #888888;
	}

	@media screen and (max-width: 1560px) {
		.shop_head .height_active {
			width: 1190px !important;
			margin: 0 auto;
			background-color: #fff;
			box-shadow: 2px 2px 2px 2px #888888;
		}
	}

	.guanbi>img {
		width: 85%;
		height: 85%;
	}

	.qqq1-q {
		width: 69px !important;
		margin-left: 0px !important;
	}
</style>
